import { Alert, Button } from "react-bootstrap"
import BadgeEstados from "../../BadgeEstado"
import { getActaDetalleHandler } from "../../../handlers/actaDetalle.handler"
import DoDisturbAltIcon from '@mui/icons-material/DoDisturbAlt';
import { useGeneralAppStore } from "../../../store/generalAppStore";
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';

const Incompleta = ({ aPrev, aPos, amp, amt, acta }) => {

    const { handlerModal } = useGeneralAppStore();
    return (
        <div>
            {
                aPos?.some(acta => acta?.estado_id == 8)
                    ?
                    <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                        <div className="bg-white d-flex flex-column align-items-center gap-3 p-2 py-4 border rounded shadow-lg w-100">
                            <div className="d-flex flex-column align-items-center gap-1">
                                <b className="text-center">Se detectaron actas posteriores en <BadgeEstados estado_id={8} /></b>
                                <p className="m-0">Anule el envio marcandolas sin entregar</p>
                                <div className="d-flex gap-2 justify-content-center align-items-center flex-wrap">
                                    {
                                        aPos?.filter(acta => acta?.estado_id == 8).map((a, index) => {
                                            return (
                                                <div key={index}
                                                    className={`bg-warning px-2 rounded  text-white fw-bold `}
                                                    style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                    onClick={() => {
                                                        if (index == 0) {
                                                            getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                        }
                                                    }}
                                                >
                                                    <p className="m-0 text-dark">Acta - {a?.numero_acta}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <Button variant="danger" size="sm" className="d-flex gap-1 align-items-center" onClick={() => { handlerModal({ modal: true, modalName: "actas_sin_entregar" }) }}><DoDisturbAltIcon /> Anular envio</Button>
                        </div>
                    </Alert>
                    :
                    aPrev?.some(acta => [3, 7].includes(acta?.estado_id))
                        ?
                        <Alert variant="danger" className="d-flex flex-column gap-2 align-items-center">
                            <div className="bg-white d-flex flex-column align-items-center gap-1 p-2 py-4 border rounded shadow-lg w-100">
                                <b className="text-center">Se detectaron actas con estados previos</b>
                                {
                                    aPrev?.some(acta => acta?.estado_id == 3)
                                    &&
                                    <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                        <p className="m-0 text-center">Revise toda las actas <BadgeEstados estado_id={3} /> para poder seguir</p>
                                        <div className="d-flex gap-2 justify-content-center align-items-center ">
                                            {
                                                aPrev?.filter(acta => acta?.estado_id == 3).map((a, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-secondary px-2 rounded  text-white fw-bold `}
                                                            style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                            onClick={() => {
                                                                if (index == 0) {
                                                                    getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                }
                                                            }}
                                                        >
                                                            <p className="m-0">Acta - {a?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    aPrev?.some(acta => acta?.estado_id == 7)
                                    &&
                                    <div className=" w-100 d-flex flex-column align-items-center gap-2 justify-content-center py-2">

                                        <p className="m-0 text-center">Complete toda las actas <BadgeEstados estado_id={7} /> para poder seguir</p>
                                        <div className="d-flex gap-2 justify-content-center align-items-center ">
                                            {
                                                aPrev?.filter(acta => acta?.estado_id == 7).map((a, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-danger px-2 rounded  text-white fw-bold `}
                                                            style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                            onClick={() => {
                                                                if (index == 0) {
                                                                    getActaDetalleHandler({ estado_id: a?.estado_id, id: a?.id })
                                                                }
                                                            }}
                                                        >
                                                            <p className="m-0">Acta - {a?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </Alert>
                        :
                        <Alert variant="primary" className="d-flex flex-column gap-2 align-items-center">
                            <div className="bg-white d-flex flex-column align-items-center gap-3 p-2 py-4 border rounded shadow-lg w-100">
                                <div className="d-flex flex-column justify-content-center align-items-center">
                                    <b className="text-center">Completar datos</b>
                                    <div className="text-center">Revise bien los datos y complete la información para poder aprobar el acta o anule de ser necesario</div>
                                </div>
                                <div className="d-flex gap-2 align-items-center justify-content-center">
                                    <Button size="sm " variant="primary" className="d-flex align-items-center  gap-2 " onClick={() => { handlerModal({ modal: true, modalName: "editar_acta" }) }}><PlaylistAddCheckIcon />Completar</Button>
                                    <Button size="sm " variant="danger" className="d-flex  align-items-center gap-2" onClick={() => { handlerModal({ modal: true, modalName: "modal_confirm" }) }}><DoDisturbAltIcon />Anular</Button>
                                </div>
                            </div>
                        </Alert>
            }
        </div>
    )
}

export default Incompleta;